import React from "react";
import "../styles/footer.css";

const PHONE_NUMBER = "+36706276599";
const PHONE_TEL = `tel:${PHONE_NUMBER}`;

export default function Footer() {
  const handleFooterCallClick = (e) => {
    e.preventDefault();

    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-17865564109/hgPsCO6_qeAbEM2_-8ZC",
        value: 1.0,
        currency: "HUF",
        event_label: "footer_call",
        event_callback: () => {
          window.location.href = PHONE_TEL;
        },
      });
    } else {
      window.location.href = PHONE_TEL;
    }
  };

  return (
    <footer className="footer" id="contact">
      <div className="container footer-inner">
        {/* LEFT COLUMN */}
        <div className="footer-left">
          <h3 className="footer-title">Kapcsolat</h3>

          <p>
            <strong>Telefon:</strong>{" "}
            <a
              href={PHONE_TEL}
              onClick={handleFooterCallClick}
              className="footer-phone-link"
            >
              +36 70 627 65 99
            </a>
          </p>

          <p>
            <strong>E-mail:</strong>{" "}
            <a href="mailto:autokolcsonzoszolnok@outlook.com">
              autokolcsonzoszolnok@outlook.com
            </a>
          </p>

          <p>
            <strong>Cím:</strong> 5000 Szolnok, Kaán Károly út 11.
          </p>

          <div className="footer-links">
            <a href="/privacy">Adatkezelési tájékoztató</a>
            <a href="/impresszum">Impresszum</a>
            <a href="/aszf">ÁSZF</a>
          </div>
        </div>

        {/* RIGHT COLUMN – GOOGLE MAP */}
        <div className="footer-right">
          <iframe
            title="map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d16525.706307378645!2d20.17103776918354!3d47.17918342407289!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4741410d43e4d4e5%3A0xfac15bae94fd4d64!2zQXV0w7Nrw7ZsY3PDtm56xZEgU3pvbG5vaw!5e1!3m2!1shu!2shu!4v1765658043711!5m2!1shu!2shu"
            loading="lazy"
            allowFullScreen
            className="footer-map"
          ></iframe>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} Autókölcsönző Szolnok – Minden jog
          fenntartva.
        </p>
      </div>
    </footer>
  );
}
